import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./pin-gateway-warning.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import PinGatewayWarningEntry from "./pin-gateway-warning-entry";
import { makeStyleable } from "../../../../helper/icon-helper";
import IconPin from "../../../../dynamicicons/icon-pin";
import IconGPSOff from "../../../../dynamicicons/icon-gps-off";
import VelavuButton from "../../../../elements/velavu-button";
import VelavuNotice from "../../../../elements/velavu-notice/velavu-notice";
import IconWarning from "../../../../dynamicicons/icon-warning";

export interface PinGatewayWarningProps {
	onNext?: () => void;
	onClose?: () => void;
}

export default function PinGatewayWarning(props: PinGatewayWarningProps) {
	const { t } = useTranslation();

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.pin_gateway.warning.header")}
				onClose={props.onClose}
			/>

			<div className={styles.content}>
				<PinGatewayWarningEntry
					icon={makeStyleable(IconPin)}
					title={t(
						"dashboard.pin_gateway.warning.fixed_location_title",
					)}
					subtitle={t(
						"dashboard.pin_gateway.warning.fixed_location_subtitle",
					)}
				/>

				<PinGatewayWarningEntry
					icon={makeStyleable(IconGPSOff)}
					title={t("dashboard.pin_gateway.warning.poor_gps_title")}
					subtitle={t(
						"dashboard.pin_gateway.warning.poor_gps_subtitle",
					)}
				/>

				<VelavuNotice type="warning" icon={makeStyleable(IconWarning)}>
					{t("dashboard.pin_gateway.warning.gps_disabled_notice")}
				</VelavuNotice>
			</div>

			<div className={styles.buttonWrapper}>
				<VelavuButton
					label={t("common.next")}
					onClick={props.onNext}
					fullWidth
				/>
			</div>
		</PinnedList>
	);
}
